
import { getBufferFromBinaryData, getWordFileAsBinary } from '../components/exactera/api';
import * as JSZip from 'jszip';
import { XMLParser } from 'fast-xml-parser';
import { wordDocBinayType } from '../constants';

const transformGuid = (guid: string) => {
  // The guid from word gives us the value inside curly braces and with all upper-case letters.
  // we need to transform this to lower case with curly braces removed.
  const removedBrackets = guid.replace(/[{}]/g, '');

  return removedBrackets.toLowerCase();
};

const useDocumentIdFetcher = () => {
  const getDocumentId = async () => {
    const binaryData = await getWordFileAsBinary();
    const binaryType = wordDocBinayType;
    let fileId = '';

    try {
      const data = await getBufferFromBinaryData(binaryData, binaryType);
      const zip = await JSZip.loadAsync(data!);
      const settingsFile = zip.files['word/settings.xml'];

      if (settingsFile) {
        const xmlContent = await settingsFile.async('string');

        const options = {
          ignoreAttributes: false,
          attributeNamePrefix: 'w:',
        };
        const parser = new XMLParser(options);
        const root = parser.parse(xmlContent);
        const wordGuid = root['w:settings']['w15:docId']['w:w15:val'];

        fileId = transformGuid(wordGuid);
      }
    } catch (error) {
      console.error('Error parsing document id:', error);
    }

    return fileId;
  };

  return { getDocumentId };
};

export default useDocumentIdFetcher;